import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types'
import clsx from 'clsx';
import {connect} from 'react-redux'

const style = theme => ({
	root: {
		minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
		marginLeft: theme.components.navigation.margin.left,
		transition: theme.transitions.default.close('margin-left'),
		display: 'flex',
		flexDirection: 'column',

	},
	menuMargin: {
		marginLeft: theme.components.navigation.width,
		transition: theme.transitions.default.open('margin-left'),
	},
	container: {
		// padding: theme.spacing(2),
		flexGrow: 1,
	}
})

function Page({
	children,
	className,
	classes,
	isMenuOpen,
	floatingWorkspace
}) {
	return (
		<div className={clsx(className, classes.root, {
			[classes.menuMargin]: floatingWorkspace && isMenuOpen,
		})}>
			<div className={classes.container} >
				{children}
			</div>
		</div>
	)
}

Page.propTypes = {
	infoBarData: PropTypes.shape({
		title: PropTypes.string.isRequired,
	}),
	floatingWorkspace: PropTypes.bool,
}

Page.propDefault = {
	floatingWorkspace: false,
}

export default connect((state) => ({
	isMenuOpen: state.store.isMenuOpen
}), {

})(withStyles(style)(Page));